import React from "react";
import { Row, Col } from "react-bootstrap";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import "../styles/Location.css"
import JumboContainer from "./common/JumboContainer";
import ContactForm from './common/ContactForm';
import Heading from './common/Heading';
import { useTranslation } from 'react-i18next';
import { CONTACT_LABEL } from '../data/i18n/contact';

const position = [26.8954449, 75.7463693];

export default function Contact() {

  const {t} = useTranslation();

  return (
    <JumboContainer id="contact" title={t(CONTACT_LABEL)}>
      <Row className="justify-content-md-center">
        <Col xs="12" lg="6" className="mb-5">
          <Map center={position} zoom={12}>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='|| Freshokartz Kiosk Locations ||'
            />

              <Marker
                key={'FRESHOKARTZ HQ'}
                position={position}
              >
                <Popup>
                  {
                    `
                    Freshokartz Agri products pvt ltd
                    716, 7th Floor, Elements mall, DCM, Ajmer Road, Jaipur
                    Elements Mall
                    192, Bhrigu Nagar Near D.C.M Market, Ajmer Rd, Jaipur, Rajasthan 302021
                    063760 24671
                    `
                  }
                  <hr />
                  <a
                    href={'https://goo.gl/maps/Bi5tj6jtLBhV46X19'}
                    target="_blank"
                    rel="noreferrer"
                    >
                    Show in Google Maps
                  </a>
                </Popup>
            </Marker>

          </Map>
        </Col>
        <Col xs="12" lg="6">
          <Heading title="Have a question?" subtitle="Let us know. We'll reach out to you." />
          <ContactForm />
        </Col>
      </Row>
    </JumboContainer>
  );
}